import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { SnackBarService } from '@core/services/snackbar.service';
import { StorageService } from '@core/services/storage.service';
import { AppRole } from '@shared/auth/enums/app-role.enum';
import { RoleRouteData } from '@shared/auth/interfaces/role-route-data.interface';
import { RoleAccessService } from '@shared/auth/services/role-access.service';
import { NavigateService } from '@shared/services/navigate.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class RoleGuard {
  private readonly roleAccessService = inject(RoleAccessService);
  private readonly storage = inject(StorageService);
  private readonly navigate = inject(NavigateService);
  private readonly snackBar = inject(SnackBarService);
  private readonly translate = inject(TranslateService);

  canActivate(route: ActivatedRouteSnapshot) {
    return this.checkAccess(route);
  }

  canActivateChild(route: ActivatedRouteSnapshot) {
    return this.checkAccess(route);
  }

  private checkAccess(route: ActivatedRouteSnapshot): boolean {
    const data = route.data as RoleRouteData;
    const roles = data?.roles;

    if (!roles?.length) {
      return true;
    }

    if (!this.storage.Employee?.id) {
      this.navigate.navigate('company-selection');
      return false;
    }

    if (this.roleAccessService.hasAnyRole(roles as AppRole[])) {
      return true;
    }

    this.snackBar.error(this.translate.instant('Auth.Errors.permissionsDenied'));
    this.navigate.go('user-settings');
    return false;
  }
}
